import { makeStyles } from 'tss-react/mui';

const name = 'MultichainDetails';

export const useMultichainDetailsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
  },
}));
